import LocalDatabase from './local/local-database'
import Logger from '@/logger'
import StorageHelper from './helper'

import Store from '@/store'
import { ACTIONS } from '@/store/actions'

import Migrations from './migrations'

/**
 * Clears down the entire local state database.
 *
 * @returns {Promise<boolean>} A flag to indicate success.
 */
const resetLocalDbAsync = async function() {
    const db = new LocalDatabase()
    try {
        await db.context.clear()
        Logger.log('Local storage database cleared.', 'Local Storage')
        return true
    } catch (err) {
        Logger.error(err)
        return false
    }
}

/**
 * Storage access methods for migration versioning.
 */
const Versioning = {

    /**
     * Reviews migrations to ensure that the core application data state is correct.
     * If it isn't then all locally stored data is cleared.
     *
     * @returns {Promise<Object>} { reset: boolean, migrationsApplied: Array } The info.
     */
    async updateSchemaAndResetAsync() {
        if (await StorageHelper.storageDisabledAsync()) return {}

        try {
            const versionStore = StorageHelper.guestLocal.versioning
            const storageMigrations = (await versionStore.getAsync()).applied
            const codeMigrations = Migrations.available.map(MigDef => new MigDef().name)
            const migrationsToApply = Migrations.available.filter(MigDef => !storageMigrations.includes(new MigDef().name))
            const reset = migrationsToApply.length > 0

            Logger.logObject({
                codeMigrations,
                storageMigrations,
                reset,
                migrationsToApply: migrationsToApply.map(MigDef => new MigDef().name),
            }, 'Analysing whether local storage needs to be reset.', 'Migrations / Local Storage')

            if (reset) {
                const cxt = await Store.dispatch(ACTIONS.ensureAuthContext)
                migrationsToApply
                    .map(MigDef => new MigDef())
                    .forEach(async(migration) => {
                        await migration.executeAsync(cxt)
                    })
                await resetLocalDbAsync()
                StorageHelper.resetAllVuexState()
                await versionStore.registerStateAsync(codeMigrations)
                Logger.log('Local storage reset triggered.', 'Migrations / Local Storage')

                return {
                    reset: true,
                    migrationsApplied: migrationsToApply.map(MigDef => new MigDef().name),
                }
            }

            Logger.log('No migrations to apply.', 'Migrations / Local Storage')

            return {
                reset: false,
            }

        } catch (err){
            Logger.log('Unable to update local storage data structures', 'Migrations / Local Storage')
            throw err
        }
    },
}

export default Versioning
